import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Parser from "html-react-parser";
import { isEmpty } from "lodash";
import BasicBanner from "@components/BasicBanner/BasicBanner";
import Meta from "@components/Meta/Meta";
import * as CMSActions from "app/@Base/store/actions";
import * as CMSActionsAhorro from "../../store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";

import "./Sucursales.css";

const BORDER_TOP_COLOR = "#d7de00";
const ROOT = process.env.REACT_APP_CMS_STATIC;

const Sucursales = () => {
  const dispatch = useDispatch();
  const [banner, setBanner] = useState({});
  const [button, setButton] = useState({});
  const [provinces, setProvinces] = useState([]);
  const [services, setServices] = useState([]);
  const [branchOffices, setBranchOffices] = useState([]);
  const [filters, setFilters] = useState({});
  const [searching, setSearching] = useState(false);

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  //Selectores de estado
  const { loggedUser } = useSelector(({ Base }) => Base?.User);
  const { provincias } = useSelector(({ Base }) => Base.Catalogos);
  const { servicios } = useSelector(({ Base }) => Base.Catalogos);
  const { sucursales } = useSelector(({ Base }) => Base.Catalogos);
  const { sucursalesCMS } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );
  const { cantones } = useSelector(({ Base }) => Base.Catalogos);
  const { distritos } = useSelector(({ Base }) => Base.Catalogos);

  const defRoute = {
    title: "Sucursales | Ahorro y Crédito",
    description: "Encuentre la información de todas las sucursales de nuestra institución."
  }

  useEffect(() => {
    dispatch(CMSActionsAhorro.getCMSSucursales());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { token } = loggedUser;
    if (token) {
      isEmpty(provincias) && dispatch(CMSActions.getProvincias(token));
      isEmpty(servicios) && dispatch(CMSActions.getServicios(token));
      isEmpty(sucursales) && dispatch(CMSActions.getSucursales(token));
      isEmpty(cantones) && dispatch(CMSActions.getCantones(token));
      isEmpty(distritos) && dispatch(CMSActions.getDistritos(token));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedUser]);

  //Accediendo y asignando datos.
  useEffect(() => {
    !isEmpty(provincias) && setProvinces(provincias);
  }, [provincias]);

  useEffect(() => {
    !isEmpty(servicios) && setServices(servicios);
  }, [servicios]);

  useEffect(() => {
    !isEmpty(sucursales) && setBranchOffices(sucursales);
  }, [sucursales]);

  useEffect(() => {
    if (!isEmpty(sucursalesCMS)) {
      let backgroundImage;
      let mainImage = {
        img:
          ROOT + sucursalesCMS.aCSucursalBannerBackground[0].heroImage.urls[0],
        alt: "Sucursales",
      };
      let title = sucursalesCMS.aCSucursalBannerBackground[0].copyText;

      let buttonImage = "";

      if (isIphoneLandscape) {
        backgroundImage =
          ROOT +
          sucursalesCMS.aCSucursalBannerBackground[0].imagendefondoMovil
            .urls[0];
        buttonImage =
          ROOT + sucursalesCMS.aCBotonComoLlegar[0].imagenMovil.urls[0];
      } else if (isIpadPortrait) {
        backgroundImage =
          ROOT +
          sucursalesCMS.aCSucursalBannerBackground[0].imagendeFondoIpadPortrait
            .urls[0];
        buttonImage = ROOT + sucursalesCMS.aCBotonComoLlegar[0].imagen.urls[0];
      } else if (isDesktop) {
        backgroundImage =
          ROOT +
          sucursalesCMS.aCSucursalBannerBackground[0].imagendeFondo.urls[0];
        buttonImage = ROOT + sucursalesCMS.aCBotonComoLlegar[0].imagen.urls[0];
      }

      setBanner({
        backgroundImage: {
          img: backgroundImage,
          alt: "Banner de Sucursales",
        },
        mainImage: mainImage,
        title: title,
      });
      setButton({
        img: buttonImage,
        alt: "¿Cómo Llegar?",
      });
    }
  }, [sucursalesCMS, isIphoneLandscape, isIpadPortrait, isDesktop]);

  const filterBranchOffices = () => {
    if (!isEmpty(filters)) {
      let filtersEmpty = true;
      let branchOfficesFiltered = [];
      // Recorre cada filtro ingresado
      Object.keys(filters).forEach((key) => {
        // valida si posee filtro de provincia, y un valor valido.
        if (
          key === "Province" &&
          !isEmpty(filters[key]) &&
          +filters[key] !== 0
        ) {
          filtersEmpty = false;
          if (branchOfficesFiltered.length === 0) {
            branchOfficesFiltered = [
              ...branchOfficesFiltered,
              ...sucursales.filter(
                (branchOffice) => branchOffice.IdProvincia === +filters[key]
              ),
            ];
          } else {
            branchOfficesFiltered = branchOfficesFiltered.filter(
              (branchOffice) => branchOffice.IdProvincia === +filters[key]
            );
          }
          // si no tiene resultados termina el filtrado.
          if (branchOfficesFiltered.length === 0) {
            // dispatch(
            //   infoNotification({
            //     title: Messages.NOTIF_TITLE_SEARCH,
            //     message: Messages.NO_RESULTS,
            //   })
            // );
            return;
          }
        } else if (
          key === "Service" &&
          !isEmpty(filters[key]) &&
          +filters[key] !== 0
        ) {
          //Valida si tiene el filtro de nombre y un valor valido.
          filtersEmpty = false;
          if (branchOfficesFiltered.length === 0) {
            branchOfficesFiltered = [
              ...branchOfficesFiltered,
              ...sucursales.filter((branchOffice) =>
                branchOffice.Servicios.find(
                  (service) => service === +filters[key]
                )
              ),
            ];
          } else {
            branchOfficesFiltered = branchOfficesFiltered.filter(
              (branchOffice) =>
                branchOffice.Servicios.find(
                  (service) => service === +filters[key]
                )
            );
          }
          // si no tiene resultados termina el filtrado.
          if (branchOfficesFiltered.length === 0) {
            // dispatch(
            //   infoNotification({
            //     title: Messages.NOTIF_TITLE_SEARCH,
            //     message: Messages.NO_RESULTS,
            //   })
            // );
            return;
          }
        }
      });

      // Si los filtros estaban vacios devuelve todas las sucursales o caso contrario las filtradas
      filtersEmpty
        ? setBranchOffices(sucursales)
        : setBranchOffices(branchOfficesFiltered);
    } else {
      setBranchOffices(sucursales);
      // dispatch(
      //   warningNotification({
      //     title: Messages.NOTIF_TITLE_SEARCH,
      //     message: Messages.NO_SEARCH_CRITERIA,
      //   })
      // );
    }
  };

  useEffect(() => {
    if (searching) {
      filterBranchOffices();
      setSearching(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searching]);

  const filterHandler = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <div className="branchOffice-container">
        <BasicBanner
          backgroundImage={banner.backgroundImage}
          mainImage={banner.mainImage}
          title={banner.title}
        />
        <div className="filters-container">
          <h2 className="filter-title">Buscar sucursales por:</h2>
          <div className="filter-form">
            <div className="form-group">
              <label className="form-label" htmlFor="Province">
                Provincia
              </label>
              <select
                className="form-select3"
                id="Province"
                name="Province"
                onChange={filterHandler}
              >
                <option key={0} value={0}>
                  Todas
                </option>
                {provinces.map((item, index) => {
                  return (
                    <option key={index + 1} value={item.Id}>
                      {item.Nombre}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="Service">
                Servicios brindados
              </label>
              <select
                className="form-select3"
                id="Service"
                name="Service"
                onChange={filterHandler}
              >
                <option key={0} value={0}>
                  Todos
                </option>
                {services.map((item, index) => {
                  return (
                    <option key={index + 1} value={item.Id}>
                      {item.Nombre}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="btn-container">
              <button
                className="form-btn"
                type="button"
                id="SearchButton"
                onClick={() => setSearching(true)}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
        <div className="branchOffices-list">
          {branchOffices &&
            branchOffices.map((branchOffice, index) => (
              <div key={index} className="branchOffice-item">
                <div className="branchOffice-title">
                  <p>{branchOffice.Nombre}</p>
                </div>
                <div
                  className="branchOffice-body"
                  style={{ borderTop: `3px solid ${BORDER_TOP_COLOR}` }}
                >
                  <span className="branchOffice-text-body">
                    {Parser(branchOffice.Descripcion)}
                  </span>
                  <div className="w-100">
                    <div className="button-container">
                      <div className="cmsButton-map">
                        <a
                          className="branchOffice-anchor"
                          href={branchOffice.LocacionUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img"
                            src={button.img}
                            alt={button.alt}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Sucursales;
